import {
  area as turfArea,
  multiPolygon as turfMultiPolygon,
  polygon as turfPolygon,
} from '@turf/turf'
import { fromBlob } from 'geotiff'
import L from 'leaflet'

import { GeoJSONObject } from '@/types/geospatial'

export const getInfosFromGeoJSON = async (geoJson: GeoJSONObject) => {
  const filename = _getFilenameFromGeoJSON(geoJson)
  const bounds = _getBoundsFromGeoJSON(geoJson)
  const interestArea = _getInterestAreaFromGeoJSON(geoJson)

  return { filename, bounds, interestArea }
}

export const getTiffParameters = async (tif: File) => {
  try {
    const file = await fromBlob(tif)
    const image = await file.getImage()
    const [coord_x, coord_y] = image.getOrigin()
    const px_res = image.getResolution()[0]

    const gsd =
      Math.abs(px_res) < 0.00001
        ? Math.abs(px_res) * 111139 * 100
        : Math.abs(px_res) * 100

    return { coord_x, coord_y, px_res, gsd, bounds: image.getBoundingBox() }
  } catch (err) {
    throw new Error(`O arquivo ${tif.name} é incompatível ou está corrompido`)
  }
}

const _getFilenameFromGeoJSON = (geoJSON: GeoJSONObject) => {
  const [filename] = Object.entries(geoJSON)
    .map(([key, name]) => (key === 'fileName' ? name : undefined))
    .filter(Boolean)

  if (!filename)
    throw new Error('Ocorreu um erro ao encontrar no nome do arquivo!')

  return String(filename)
}

const _getBoundsFromGeoJSON = (geoJSON: GeoJSONObject) => {
  const bounds = L.geoJSON(geoJSON).getBounds()
  return bounds.getCenter()
}

const _getInterestAreaFromGeoJSON = (geoJSON: GeoJSONObject) => {
  const HECTARE_VALUE = 10000

  const totalArea = geoJSON.features
    .map((feature) =>
      turfArea(
        feature.geometry.type === 'MultiPolygon'
          ? turfMultiPolygon(feature.geometry.coordinates)
          : turfPolygon(feature.geometry.coordinates),
      ),
    )
    .reduce((sum: number, area: number) => sum + area, 0)

  return totalArea / HECTARE_VALUE
}
